export default "__VITE_ASSET__Cp4A8air__"